import React, { useEffect } from "react";
// MDB Shims 
import Button from "../../Component/MDBShim/Button";
import Card from "../../Component/MDBShim/Card";
import CardBody from "../../Component/MDBShim/CardBody";
import CardHeader from "../../Component/MDBShim/CardHeader";
import Col from "../../Component/MDBShim/Col";
import Collapse from "../../Component/MDBShim/Collapse";
import Container from "../../Component/MDBShim/Container";
import MDBBtn from "../../Component/MDBShim/MDBBtn";
import MDBIcon from "../../Component/MDBShim/MDBIcon";
import MDBSelect from "../../Component/MDBShim/MDBSelect";
import Modal from "../../Component/MDBShim/Modal";
import ModalBody from "../../Component/MDBShim/ModalBody";
import ModalFooter from "../../Component/MDBShim/ModalFooter";
import MDBInput from "../../Component/MDBShim/MDBInput";
import MDBNav from "../../Component/MDBShim/MDBNav";
import MDBNavItem from "../../Component/MDBShim/MDBNavItem";
import MDBNavLink from "../../Component/MDBShim/MDBNavLink";
import Row from "../../Component/MDBShim/Row";
import Spinner from "../../Component/MDBShim/Spinner";
import MDBTabContent from "../../Component/MDBShim/MDBTabContent";
import MDBTabPane from "../../Component/MDBShim/MDBTabPane";
import MDBFormInline from "../../Component/MDBShim/MDBFormInline";
import MDBCol from "../../Component/MDBShim/MDBCol";
import MDBRow from "../../Component/MDBShim/MDBRow";
import MDBModalHeader from "../../Component/MDBShim/MDBModalHeader";
import MDBCardBody from "../../Component/MDBShim/MDBCardBody";
import MDBCard from "../../Component/MDBShim/MDBCard";
import MDBModalFooter from "../../Component/MDBShim/MDBModalFooter";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import "./deliveries.css";
import '../../Components/jkTooltip.css';
import OrderService from "../Security/OrderService/orderService";
import BtProductService from "../Security/BtProductService/btProductService";
import CallLogService from "../Security/CallLogService/callLogService";
import PropTypes from "prop-types";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import NoteService from "../Security/NoteService/noteService";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.material.blue.light.compact.css";
import ReadyToScheduleGrid from "./readyToScheduleGrid";
import MUITextField from "@mui/material/TextField";
import MUIMenuItem from "@mui/material/MenuItem";
import GlobalFunctions from "../Filters/GlobalFunctions";
import partsService from "../Security/ProductService/partsService";
import { DateTimePicker as MUIDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import MUIGreyColor from "@mui/material/colors/grey";
import LayerLegacy from "../../LayerLegacy";
import MainContext from "../../Context/MainContext/MainContext";
import MUIThemeProvider from "@mui/material/styles/ThemeProvider";
import MUICreateTheme from "@mui/material/styles/createTheme";
import MUIAlert from "@mui/material/Alert";
import Security from "../../Utility/Security";

const fixedLightMaterialUITheme = MUICreateTheme({ palette: { mode: "light" } });


// region Constants

const colorGroups = [
    [75, 192, 192, 1], [75, 90, 192, 1], [192, 75, 115, 1], [75, 188, 66, 1],
    [147, 81, 160, 1], [244, 171, 68, 1], [191, 244, 68, 1], [68, 244, 171, 1],
    [33, 75, 89, 1], [81, 97, 160, 1], [255, 210, 215, 1], [255, 210, 140, 1],
    [145, 230, 205, 1], [130, 220, 225, 1], [255, 100, 180, 1], [50, 90, 105, 1],
    [255, 245, 175, 1], [225, 160, 60, 1], [60, 40, 45, 1], [85, 10, 15, 1],
];

// endregion

export default class DeliveryList extends LayerLegacy {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false,
            techScheduleLoaded: false,
            rootData: [],

            dataNotScheduled: [],
            dataApproved: [],
            dataEquipmentOrdered: [],

            dataTechSchedule: [],
            userLocations: [],
            selectedLocationIds: [],
            locationList: [],
            editRow: {},
            toggleModal: false,
            errorMessage: "",
            noteToggle: false,
            nNote: "",
            techs: [],
            equipApproval: false,
            equipApprovalModal: false,
            isOpen: true,
            equipOrder: {},
            callRadio: null,
            callPatientNote: "",
            techTooltip: "",
            technicianText: "",
            ssAcknowledge: false,
            flatOrder: null,
            changedLocation: false,

            orderRetrieved: false,
            orderProducts: [],
            loadingFlatOrder: false,

            notesRetrieved: false,
            orderNotes: [],
            ModalTabsOneActiveItem: "1",
            idNames: [],
            patientRegistered: null,
            allLocations: [],
            serviceQuoteFromOrderId: [],
            servicePartsLoaded: false,
            firstLoad: true,
        };

        this.renderEditOrderModal = this.renderEditOrderModal.bind(this);

        setTimeout(() => {
            this.getLocalStorage();
        }, 2500);
    }

    static contextType = MainContext; // For legacy class components

    toggleCollapse() {
        this.setState((state) => ({
            isOpen: !state.isOpen,
            isLoaded: false,
        }));
        //This is necessary because otherwise the grid won't use the full width on resize
        let t = this;
        setTimeout(() => {
            t.setState({
                isLoaded: true,
            });
        }, 5);
    }

    componentDidMount() {
        this.getUserLocations();

    }
    getFlatOrder() {

        if (this.state.loadingFlatOrder || (this.state.flatOrder && this.state.flatOrder.id === this.state.editRow.id)) {
            return;
        }
        this.setState({
            loadingFlatOrder: true
        });
        OrderService.getFlatOrderActivity(this.state.editRow.id).then((res) => {

            this.setState({
                flatOrder: res,
                loadingFlatOrder: false
            });
        }).catch(() => {});


    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { allLocations } = this.context;

        if (allLocations.length > 0 && this.state.allLocations.length !== allLocations.length) {
            this.getUserLocations();
        }
    }

    // region Locations
    getUserLocations() {
        const { currentUser, allLocations, userprofileLocationsIndexed } = this.context;

        let locations = [];
        let locationSelectOptions = [];

        if (
            Security.hasPermission("user.viewAllLocations") ||
            currentUser.role === "ADMIN" ||
            currentUser.role === "EXECUTIVE_MANAGEMENT"
        ) {
            locations = allLocations;
        } else if (currentUser.userprofileLocations) {
            locations = currentUser.userprofileLocations.map(x => x.locations);
        } else {
            const userLocationIds =
                Object.values(userprofileLocationsIndexed)
                    .filter((userprofileLocation) =>
                        userprofileLocation.userprofileId === currentUser.id
                    )
                    .map((userprofileLocation) => userprofileLocation.locationsId);

            locations = allLocations.filter((location) =>
                userLocationIds.includes(location.id)
            );
        }

        locations.forEach((location) => {
            locationSelectOptions.push({
                disabled: false,
                text: location.name,
                value: location.id.toString(),
                locVal: location,
            });
        });

        this.setState({
            userLocations: locations,
            allLocations: allLocations,
            locationList: locationSelectOptions,
        });
    }

    setLocalStorage(e) {
        window.localStorage.setItem("deliveriesFilters", JSON.stringify(e));
    }

    getLocalStorage() {
        let f = window.localStorage.getItem("deliveriesFilters");

        if (f != null) {
            f = JSON.parse(f);

            let ll = this.state.locationList;

            if (ll.length > 0 && f.length > 0) {
                let v = ll.find((r) => {
                    return r.value === f[0];
                });

                let t = "";

                if (v) {
                    v.checked = true;
                    t = v.text;
                }

                this.setState({
                    locationList: ll,
                    selectedLocationText: t,
                });
            }

            this.handleLocationChange(f);
        }
    }

    handleLocationChange = (e) => {
        const ids = Array.isArray(e) ? e : [e];

        if (ids.length === 0) {
            //location was not actually changed to anything
            return;
        }

        this.setState({
            selectedLocationIds: ids,
            dataTechSchedule: [],
        });
        if (ids.length > 0) {
            this.retrieveDeliveries(ids);
            this.setLocalStorage(ids);
        }
    };

    getIDs(productsOverride = null, orderId = null) {
        const { companyName } = this.context;
        if (companyName !== "corkmedical") {
            let arr = [];
            let products = productsOverride || this.state.orderProducts || [];
            if (products.length > 0) {
                products.forEach((product, index) => {
                    arr.push(this.getProductsDetails(product, index));
                });
            }
        }
    }

    getProductsDetails(product, index) {
        const { companyName } = this.context;
        if (companyName !== "corkmedical") {
            let a = [];

            a.push({
                text: "N/A",
                value: "N/A",
            });

            if (product.hcpcs && product.hcpcs.length > 0) {
                BtProductService.getBtProductsByHcpcs(product.hcpcs)
                    .then((res) => {
                        res.map((t) => {
                            const itemId = t && typeof t === "object" ? t.itemId : t;
                            const itemName = t && typeof t === "object" ? t.name : t;
                            const optionText = itemId && itemName ? itemId + " - " + itemName : (itemName || itemId || "N/A");
                            const optionValue = itemId || itemName || "N/A";
                            return a.push({
                                text: optionText,
                                value: optionValue,
                                selected: res.length === 1
                            });
                        });

                        if (a.length < 1) {
                            a[0].selected = true;
                        }
                        let productList = this.state.idNames;
                        //productList.splice(index, 0, a)
                        productList[index] = a;
                        this.setState({
                            idNames: productList
                        });
                    })
                    .catch((err) => {
                        return a.push({
                            text: "N/A",
                            value: "N/A",
                        });
                    });
            }
            else {
                let productList = this.state.idNames;
                productList[index] = a;
                this.setState({
                    idNames: productList
                });
            }
        }
    }

    handleIDChange = (e, prod) => {
        const { companyName } = this.context;
        if (companyName !== "corkmedical") {
            if (prod.length === 0) {
                return;
            }
            let products = this.state.orderProducts;
            products = products.map(product => {
                if (product.id === e.id) {
                    return { ...product, btitemId: prod };
                }
                return { ...product };
            });

            this.setState({
                orderProducts: products,
            });
        }
    };

    retrieveDeliveries(ids) {
        this.setState({
            isLoaded: false,
            techScheduleLoaded: false,
        });

        // This takes the locations selected in the dropdown and adds them as the part of the parameters for api call...JK
        if (ids.length > 0) {
            OrderService.getDeliveriesForLocation(ids)
                .then((res) => {
                    this.buildTechTimeline(res);
                    this.buildDataSets(res);
                })
                .catch((err) => {
                    NotistackEnqueueSnackbar("An error occurred getting the deliveries", { variant: "error" });
                });
        }
    }

    formatDate(date) {
        if (date == null || date === "") {
            return "";
        }
        let dt = new Date(date);
        return new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
        }).format(dt);
    }

    formatTime(date) {
        if (date == null || date === "") {
            return "";
        }
        let dt = new Date(new Date(date).toString() + " UTC");
        return new Intl.DateTimeFormat("en-US", {
            hour: "numeric",
            minute: "numeric",
            second: "2-digit",
        }).format(dt);
    }

    buildDataSets(data) {
        const { companyName } = this.context;
        let d2 = [],
            d3 = [],
            d4 = [],
            today = new Date(),
            regEx = new RegExp("No Answer.+"),
            oldDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
        // Have to use reg ex since reaason is slightly different in Rehab compared to Cork...JK

        let blank = data.orders.filter((bl) => {
            return !bl.reason || bl.reason === null || regEx.test(bl.reason);
        });
        blank.map((item) => {
            return d3.push({
                order: item.id,
                type: item.orderType,
                name: item.patientName,
                address: item.address,
                city: item.city,
                state: item.state,
                zip: item.zipCode,
                reason: item.reason,
                category: item.category,
                product: item.product,
                pts: item.totalPoints,
                lastNoteDate: this.formatDate(item.lastNoteDate),
                answered: item.answered,
                calledBy: item.calledBy,
                calledOn: item.calledOn,
            });
        });

        let eo = data.orders.filter((bl) => {
            return bl.reason && bl.reason === "Equipment Ordered";
        });
        eo.map((item) => {
            return d4.push({
                order: item.id,
                category: item.category,
                product: item.product,
                phone: item.phone,
                name: item.patientName,
                equipmentOrderedDate: item.equipmentOrderedDate,
                lastNoteDate: GlobalFunctions.formatDate(item.lastNoteDate),
                answered: item.answered,
                calledBy: item.calledBy,
                calledOn: item.calledOn,
            });
        });

        // let rest = data.orders.filter(bl => {
        //     return bl.reason !== 'Equipment Ordered'
        // });
        data.orders.map((item) => {
            let tc = item.technicianId
                ? data.techs.find((x) => x.id === item.technicianId)
                : null;
            return d2.push({
                patientRegistered: item.patientRegistered,
                missingIds: companyName !== "corkmedical" ? item.missingIds : false,
                order: item.id,
                type: item.orderType,
                address: item.address,
                city: item.city,
                state: item.state,
                zip: item.zipCode,
                reason: item.reason,
                name: item.patientName,
                patientId: item.patientId,
                product: item.product,
                pts: item.totalPoints,
                tech: tc ? tc.username : "",
                scheduledDate: GlobalFunctions.formatDate(item.scheduledDeliveryDate),
                expectedShipDate: item.expectedShipDate || "",
                approvalDate: GlobalFunctions.formatDate(item.approvalDate),
                equipmentOrderedDate: item.equipmentOrderedDate,
                lastNoteDate: GlobalFunctions.formatDate(item.lastNoteDate),
                pediatric: oldDate <= new Date(item.dateOfBirth) ? "Yes" : "No",
            });
        });

        this.setState({
            dataNotScheduled: d2,
            dataApproved: d3,
            dataEquipmentOrdered: d4,
            rootData: data.orders,
            techs: data.techs,
            isLoaded: true,
        });
    }

    buildTechTimeline(data) {
        let d4 = this.state.dataTechSchedule,
            ids = this.state.selectedLocationIds,
            techs = data.techs;

        if (ids.length > 0) {
            this.setState({ techScheduleLoaded: false });

            d4 = [];

            let filteredData = data.orders.filter((order) => {
                return (
                    order.scheduledDeliveryDate !== null && order.technicianId !== null
                );
            });

            techs.forEach((tech, index) => {
                let x = index % colorGroups.length;
                let currStyle = {
                    tech: tech.id,
                    stroke: [0, 0, 0, 0.5],
                    fill: colorGroups[x],
                    visible: true,
                    name: tech.firstname + " " + tech.lastname
                };

                let orderCount = 0,
                    row = {
                        isOpen: true,
                        techId: tech.id,
                        name: tech.firstname + " " + tech.lastname + " - ",
                        deliveries: [],
                        stroke: "1px solid rgba(" + currStyle.stroke.toString() + ")",
                        fill: "rgba(" + currStyle.fill.toString() + ")",
                    };

                let ords = filteredData.filter((ord) => {
                    return ord.technicianId === tech.id;
                });

                ords.forEach((od, idx) => {
                    let orderDate = new Date(
                        od.scheduledDeliveryDate
                    ).toLocaleDateString();

                    let exists = row.deliveries.findIndex((del) => {
                        return del.date === orderDate;
                    });

                    if (exists > -1) {
                        row.deliveries[exists].orders.push(od);
                    } else {
                        row.deliveries.push({
                            date: orderDate,
                            orders: [od],
                        });
                    }

                    orderCount++;
                });

                row.deliveries.sort((a, b) => {
                    return new Date(a.date) - new Date(b.date);
                });

                row.name += orderCount.toString();
                d4.push(row);
            });

            this.setState({
                dataTechSchedule: d4,
                techScheduleLoaded: true,
                techs: techs,
            });
        }
    }

    handleDeliveryDate(e) {
        let row = this.state.editRow;
        let eOrder = this.state.flatOrder;

        if (e) {
            let newDate = moment(e).clone();
            if (newDate.second() === 1 && newDate.millisecond() === 1) {
                newDate.hour(12).minute(0).second(1).millisecond(1);
            }

            let q = new moment.utc(newDate);
            let v = q.format("YYYY-MM-DDTHH:mm:ss");
            row.scheduledDeliveryDate = v;
            eOrder.scheduledDeliveryDate = e;
        } else {
            eOrder.scheduledDeliveryDate = null;
            row.scheduledDeliveryDate = null;
        }

        this.setState({
            editRow: row,
            flatOrder: eOrder
        });
    }

    handleTechChange(e) {
        let row = this.state.editRow,
            eOrder = this.state.flatOrder,
            text = "";

        if (e) {
            eOrder.technicianId = e.id;
            row.technicianId = e.id;
            text = e.firstname + " " + e.lastname;
        } else {
            row.technicianId = null;
            eOrder.technicianId = null;
        }

        this.setState({
            editRow: row,
            technicianText: text,
            flatOrder: eOrder,
        });
    }

    handleReasonChange(e) {
        const { reasons } = this.context;
        let row = this.state.editRow;
        let order = this.state.flatOrder;

        if (e) {
            let r = reasons.find((o) => {
                return e === o.id;
            });

            if (r) {
                row.reason = r.description;
                row.reasonId = r.id;
                order.orderStatusReasonId = r.id;
            } else {
                row.reason = null;
                order.orderStatusReasonId = null;
            }
        }
        else {
            row.reason = null;
            row.reasonId = null;
            order.orderStatusReasonId = null;
        }

        this.setState({
            editRow: row,
            flatOrder: order,
        });
    }

    updateOrder(rowData, note) {

        const { currentUser } = this.context;
        let order = this.state.flatOrder;
        order.lastUpdatedBy = {
            id: currentUser.id,
            username: currentUser.username,
        };


        order.lastUpdatedById = currentUser.id;
        // if(this.state.changedLocation){
        // this.setState({
        // changedLocation: false
        // })
        OrderService.updateFlatOrder(order).then((res) => {

            // }

            let row = this.state.editRow;
            if (res.id == -1) {
                return NotistackEnqueueSnackbar("Patient must have a gender set before saving.", { variant: "warning" });
            }
            else if (row.id != res.id) {
                return NotistackEnqueueSnackbar("Order was recently updated. Please refresh the page and resubmit your changes.", { variant: "warning" });
            }

            if ((!row || !row.id) && rowData != null) {
                row = rowData;
            }

            if (row.id) {

                if (!row.reasonId) {
                    return NotistackEnqueueSnackbar("You must select a status reason.", { variant: "error" });
                }

                if (row.reason === "Equipment Ordered") {
                    if (!row.equipmentOrderedDate) {
                        row.equipmentOrderedDate = new Date().toLocaleString();
                    }
                }

                if (!this.state.servicePartsLoaded) {
                    this.updateProducts();
                }

                OrderService.updateDelivery(row)
                    .then((ord) => {
                        if (this.state.nNote || note) {
                            this.saveNote(row, note);
                        }
                        if (row.scheduledDeliveryDate) {
                            let noteDate = GlobalFunctions.formatDateTimeTimeZone(row.scheduledDeliveryDate);
                            // let noteDate = new Date(row.scheduledDeliveryDate).toLocaleString();
                            // row.scheduledDeliveryDate = moment
                            //     .utc(row.scheduledDeliveryDate)
                            //     .local()
                            //     .format();

                            if (this.state.ssAcknowledge) {
                                if (!this.state.nNote) {
                                    NotistackEnqueueSnackbar(
                                        "You must add a note explaining why you are scheduling with Same/Sim on file.",
                                        { variant: "error" }
                                    );
                                    return;
                                }

                                let note =
                                    currentUser.username +
                                    " acknowledged that there is a same/sim on file and scheduled the order to be delivered on " +
                                    noteDate;

                                if (this.state.technicianText) {
                                    note += " with technician " + this.state.technicianText;
                                }

                                this.saveNote(row, note);
                            }

                            if (row.technicianId && row.reason === "Scheduled") {
                                let text =
                                    "Order scheduled for " +
                                    noteDate +
                                    " by " +
                                    currentUser.username +
                                    " with technician " +
                                    this.state.technicianText;
                                this.saveNote(row, text);
                            }
                        }
                        this.toggleEditModal();
                        NotistackEnqueueSnackbar("Saved Successfully!", { variant: "success" });
                        this.setState({
                            editRow: {},
                            toggleModal: false,
                            equipApprovalModal: false,
                            callPatientModal: false,
                            equipOrder: {},
                        });
                        this.retrieveDeliveries(this.state.selectedLocationIds);
                    })
                    .catch((err) => {
                        NotistackEnqueueSnackbar("An error occurred while saving.", { variant: "error" });
                        this.setState({ isLoaded: true });
                    });
            }
        }).catch((err) => {


        });
    }

    updateProducts() {
        let prods = this.state.orderProducts;
        OrderService.updateOrderProducts(this.state.editRow.id, prods)
            .then((r) => {
                NotistackEnqueueSnackbar("Products Saved Successfully!", { variant: "success" });
            })
            .catch((err) => {
                NotistackEnqueueSnackbar("Error Saving Products", { variant: "error" });
            });
    }

    saveNote(order, noteText) {
        const { currentUser } = this.context;
        let n = noteText ? noteText : this.state.nNote;
        let note = {
            type: "ActivityNote",
            text: n,
            createdAt: new Date(),
            account: order.account,
            task: false,
            completed: false,
            activityId: order.id,
            createdBy: { id: currentUser.id, name: currentUser.username },
            createdById: currentUser.id,
        };
        NoteService.createActivityNote(order.id, note)
            .then((res) => {
                NotistackEnqueueSnackbar("Note saved", { variant: "success" });
            })
            .catch((err) => {
                NotistackEnqueueSnackbar("Error: Note not saved", { variant: "error" });
            });
        this.setState({
            nNote: "",
        });
    }

    toggleEditModal() {
        this.setState({
            toggleModal: !this.state.toggleModal,
            orderRetrieved: false,
            servicePartsLoaded: false,
            notesRetrieved: false,
            ssAcknowledge: false,
            orderProducts: [],
            orderNotes: [],
            idNames: [],
            order: {},
            technicianText: "",
            nNote: "",
        });
    }

    toggleTechRow(index) {
        let d4 = this.state.dataTechSchedule,
            tech = d4[index];

        tech.isOpen = !tech.isOpen;
        d4[index] = tech;

        this.setState({
            dataTechSchedule: d4,
        });
    }

    printTechTooltip(tech, date) {
        var mywindow = window.open("", "PRINT", "height=600,width=600");
        mywindow.document.write(
            "<html><head><title>Daily Delivery Schedule</title>"
        );
        mywindow.document.write("</head><body >");
        mywindow.document.write("<h1>" + tech + "</h1>");
        mywindow.document.write("<h1>Delivery Schedule for " + date + "</h1>");
        mywindow.document.write(document.getElementById("techTooltip").innerHTML);
        mywindow.document.write("</body></html>");
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); //  for IE >= 10*/
        mywindow.print();
        mywindow.close();
        return true;
    }

    getTooltipContent(orders, tech, date) {
        orders.sort((a, b) => {
            return (
                new Date(a.scheduledDeliveryDate) - new Date(b.scheduledDeliveryDate)
            );
        });

        let ary = [];

        orders.forEach((ord, index) => {
            let address =
                !ord.address && !ord.city && !ord.state && !ord.zipCode
                    ? "*** No Address Provided ***"
                    : ord.address +
                    "\n\t" +
                    ord.city +
                    ", " +
                    ord.state +
                    " " +
                    ord.zipCode;
            let phone = ord.phone ? ord.phone : "*** No phone Provided ***";
            ary.push(
                <p
                    key={index}
                    className={"techTooltipBoxInner"}
                    onClick={() => this.printTechTooltip(tech, date)}
                >
                    {"Order ID: " + ord.id} <br />
                    {"Patient Name: " + ord.patientName} <br />
                    {"Delivery Time: " + GlobalFunctions.formatTime(ord.scheduledDeliveryDate)}{" "}
                    <br />
                    {"Address: " + address} <br />
                    {"Phone: " + phone} <br />
                    {"Equipment: " + ord.product}
                </p>
            );
        });
        this.setState({
            techTooltip: ary,
        });
    }

    clientCSV() {
        let result,
            ctr,
            keys = [
                "order",
                "name",
                "approvalDate",
                "address",
                "city",
                "state",
                "zip",
                "lastNoteDate",
                "type",
                "product",
                "pts",
                "reason",
                "scheduledDate",
                "tech",
            ],
            headers = [
                "Order ID",
                "Patient Name",
                "Approval Date",
                "Address",
                "City",
                "State",
                "Zip",
                "Last Note Date",
                "Order Type",
                "Product",
                "Points",
                "Reason",
                "Scheduled Date",
                "Technician",
            ],
            columnDelimiter = ",",
            lineDelimiter = "\n",
            data = this.state.dataNotScheduled;

        if (data == null || !data.length) {
            return null;
        }

        result = "";
        result += headers.join(columnDelimiter);
        result += lineDelimiter;

        data.forEach(function (item) {
            ctr = 0;
            keys.forEach(function (key) {
                if (ctr > 0) {
                    result += columnDelimiter;
                }

                if (item[key]) {
                    let v = item[key].toString();
                    result += v.replace(/,/g, " ");
                } else {
                    result += "";
                }

                ctr++;
            });
            result += lineDelimiter;
        });

        this.downloadBlob(result, "DeliveriesList.csv");
    }

    downloadBlob(csvData, filename) {
        let blob = new Blob([csvData], {
            type: "application/csv;charset=utf-8;",
        });

        if (window.navigator.msSaveBlob) {
            // FOR IE BROWSER
            navigator.msSaveBlob(blob, filename);
        } else {
            // FOR OTHER BROWSERS
            let link = document.createElement("a"),
                csvUrl = URL.createObjectURL(blob);

            link.href = csvUrl;
            link.style = "visibility:hidden";
            link.download = filename;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    getOrderProducts(id) {
        OrderService.getOrderActivity(id)
            .then((ord) => {
                // let prod = ord.orderActivityProducts.map(x => x.products);
                if(!ord.orderActivityProducts || ord.orderActivityProducts.length<1){
                    this.setState({
                        order: ord,
                    });
                    this.getServiceQuoteByOrder(id);
                }

                else {
                    const mappedProducts = ord.orderActivityProducts.map(x => x.products);
                    this.setState({
                        orderRetrieved: true,
                        orderProducts: mappedProducts,
                        order: ord,
                    });
                    this.getIDs(mappedProducts, id);
                }


            })
            .catch(() => {});
    }
    sortNotes(allNotes) {

        let sorted = allNotes.sort((a, b) => {
            let da = new Date(a.createdAt).getTime(),
                db = new Date(b.createdAt).getTime();

            return da > db ? -1 : 1;
        });

        return sorted;
    }
    getOrderNotes(id) {
        NoteService.getNotes(id)
            .then((n) => {
                let notes = this.sortNotes(n);
                this.setState({
                    notesRetrieved: true,
                    orderNotes: notes,
                });
            })
            .catch(() => {});
    }
    getServiceQuoteByOrder(id) {
        if (id == null || id === "") {
            return;
        }
        partsService.getServiceOrderProductsByOrder(id)
            .then((r) => {
                this.setState({
                    orderProducts: r,
                    orderRetrieved: true,
                    serviceQuoteFromOrderId: r,
                    servicePartsLoaded: true
                });
                this.getIDs();
            })
            .catch(() => {
                this.setState({});
            });
    }


    renderEditOrderModal = (id) => {
        let row = this.state.rootData.find((item) => {
            return item.id === id;
        });
        if (row) {
            let techs = this.state.techs,
                technicianText = "";

            let index = techs.find((rep) => {
                return rep.id === row.technicianId;
            });

            if (index) {
                technicianText = index.firstname + " " + index.lastname;
            }

            this.setState({
                editRow: row,
                selectedTech: row.technicianId,
                technicianText: technicianText,
                nNote: "",
            });
            this.getOrderProducts(id);
            this.getOrderNotes(id);
            this.toggleEditModal();
        } else {
            NotistackEnqueueSnackbar("Could not locate the order.", { variant: "warning" });
        }
    };

    changeByRef(prop, val) {
        if (prop === "serviceLocation") {
            this.setState({
                changedLocation: true
            });
        }
        let o = null;

        if (val) {
            o = {
                name: val.name,
                id: val.id,
            };
        }

        this.setAndUpdate(prop, o);
    }

    setAndUpdate(prop, val) {
        if (val && val.toString() === "Invalid date") {
            val = null;
        }
        let eOrder = this.state.flatOrder;

        if (eOrder.hasOwnProperty(prop)) {
            eOrder[prop] = val;
        }

        if (eOrder.activity.hasOwnProperty(prop)) {
            eOrder.activity[prop] = val;
        }

        if (eOrder.patient.hasOwnProperty(prop)) {
            eOrder.patient[prop] = val;
        }

        this.setState({ flatOrder: eOrder });

    }

    renderServiceLocationDropdown() {
        const { allLocations } = this.context;
        if (!this.state.flatOrder) {
            return;
        }
        let eOrder = this.state.flatOrder;

        let index = allLocations.find((loc) => {
            if (eOrder.serviceLocation) {
                return loc.id === eOrder.serviceLocation.id;
            } else if (eOrder.serviceLocationId) {
                return loc.id === eOrder.serviceLocationId;
            } else {
                return null;
            }
        });

        return (
            <div className={"uiOutlines"}>
                <MUITextField
                    id="Service-Location"
                    select
                    size={"small"}
                    fullWidth
                    label="Service Location"
                    value={index ? index : ""}
                    onChange={(e) => {
                        this.changeByRef("serviceLocation", e.target.value);
                        this.setAndUpdate("serviceLocationId", e.target.value.id);
                    }}
                    variant="outlined"
                >
                    {allLocations.map((option, idx) => {
                        return (
                            <MUIMenuItem key={idx} value={option}>
                                {option.name}
                            </MUIMenuItem>
                        );
                    })}
                </MUITextField>
            </div>
        );
    }

    renderTechnicianDropdown() {
        const { techs } = this.context;
        // let techs = this.state.techs,
        let row = this.state.editRow;

        //let index = techs.find((rep) => {
        //    return rep.id === row.technicianId;
        //});
        if (techs && techs.length > 0) {
            let index = techs.find((rep) => {
                if (row.technicianId) {
                    return rep.id === row.technicianId;
                } else {
                    return null;
                }
            });

            var resp = techs
                .filter(t => t.active === true)
                .sort((a, b) => {
                    if (a.firstname && a.lastname && b.firstname && b.lastname)
                        return a.firstname.trim() + " " + a.lastname.trim() > b.firstname.trim() + " " + b.lastname.trim() ? 1 : -1;
                    else
                        return 1;
                });

            return (
                <div className={"uiOutlines"}>
                    <MUITextField
                        disabled={this.disableCheck()}
                        id="Technicians"
                        select
                        size="small"
                        fullWidth
                        label="Technician"
                        value={index ? index : ""}
                        onChange={(e) => this.handleTechChange(e.target.value)}
                        variant="outlined"
                    >
                        <MUIMenuItem key={-1} value={null}>
                            {"(Remove Technician)"}
                        </MUIMenuItem>
                        {resp.map((option, idx) => {
                            return (
                                <MUIMenuItem key={idx} value={resp[idx]}>
                                    {option.firstname + " " + option.lastname}
                                </MUIMenuItem>
                            );
                        })}
                    </MUITextField>
                </div>
            );
        }
    }

    renderProductsList() {
        const { companyName } = this.context;
        let p = this.state.orderProducts;

        if (this.state.orderRetrieved && p) {
            return (
                <div>
                    <MDBRow style={{ textDecoration: "underline", fontWeight: "bold" }}>
                        <MDBCol size="4" >{this.state.servicePartsLoaded ? "Brightree Product" : "Product"} </MDBCol>
                        <MDBCol size="4">{companyName !== "corkmedical" ? (this.state.servicePartsLoaded ? "Brightree Product" : "HCPCS") : ""}</MDBCol>
                        <MDBCol size="1">Qty </MDBCol>
                        <MDBCol size="3">{this.state.servicePartsLoaded ? "" : "Serial"} </MDBCol>
                    </MDBRow>
                    {/* To catch tickets not created in new system and need a piece of equipment to be able to be delivered */}
                    {p && p.length < 1 ?
                        <MDBRow className={"eqRow"}>
                            <Button
                                className={"registrationButtons"}
                                disabled={false}
                                color={"blue"}
                                size="md"
                                onClick={() => this.addPartForDelivery("30day")}>
                                Add 30 Day Fit for You
                            </Button>
                            <Button
                                className={"registrationButtons"}
                                disabled={false}
                                color={"blue"}
                                size="md"
                                onClick={() => this.addPartForDelivery("techSkilled")}>
                                Add Tech Skilled Labor
                            </Button>
                            <Button
                                className={"registrationButtons"}
                                disabled={false}
                                color={"blue"}
                                size="md"
                                onClick={() => this.addPartForDelivery("fieldService")}>
                                Add Field Service Diagnosis
                            </Button>

                        </MDBRow>
                        :
                        <div></div>

                    }

                    {p.map((prod, idx) => {
                        return (
                            <MDBRow key={idx} size="12" className={"eqRow"} style={{}}>
                                <MDBCol size="4" style={{}}>
                                    {this.state.servicePartsLoaded ? prod.name :
                                        (prod.productType ? prod.productType.name : "") +
                                        " " + (prod.productSubType ? prod.productSubType.name : "")}
                                </MDBCol>
                                <MDBCol size="4" style={{ marginRight: "16px"}}>
                                    {companyName !== "corkmedical" ?
                                        this.state.servicePartsLoaded ?
                                            <MDBCol size="4"  style={{width: "100%" }}>
                                                {(prod.hcpcs ? prod.hcpcs : "noname")}
                                            </MDBCol>

                                            :
                                            <MDBSelect
                                                className={"smallMargin searchField"}
                                                outline={true}
                                                search={true}
                                                color="info"
                                                selected={prod.btitemId || "Choose Product"}
                                                style={{ margin: "5px", width: "100%" }}
                                                options={this.state.idNames[idx]}
                                                getValue={this.handleIDChange.bind(this, prod)}
                                            />
                                        : ''}
                                </MDBCol>
                                <MDBCol size="1" style={{}}>{prod.qty}</MDBCol>
                                {this.state.servicePartsLoaded ? null : <MDBCol size="3" style={{}}>{prod.serial}</MDBCol>}

                            </MDBRow>
                        );
                    })}
                </div>
            );
        } else {
            return (
                <MDBRow>
                    <MDBCol />
                    <MDBCol>
                        <Spinner small />
                    </MDBCol>
                </MDBRow>
            );
        }
    }

    addPartForDelivery(val) {
        this.setState({
            orderRetrieved: false,
            orderProducts: null,
            productsForNote: [],

            serviceQuoteFromOrderId: null,
            servicePartsLoaded: false
        });
        const { currentUser, productTypes, productSubTypes } = this.context;
        let id = null;
        if (val === "techSkilled") {
            //1963 Tech Skilled Labor
            id = 1963;
        }
        else if (val === "30day") {
            //70  30 Day Fit for You
            id = 70;
        } else if (val === "fieldService") {
            //1964 Field Service Diagnosis
            id = 1964;
        }

        let newItem = {
            abnRequired: false,
            amount: 0,
            approved: true,
            hcpcs: "na",
            isRental: false,
            orderActivityProducts:
                { orderActivityId: this.state.editRow.id },

            points: 0,
            productSubTypeId: id,
            productTypeId: 27,
            qty: 1,
            serial: "",
            updatedById: currentUser.id,
            updatedOn: new Date().toISOString()
        };
        let noteText =
            currentUser.firstname +
            " " +
            currentUser.lastname +
            " approved order " +
            this.state.editRow.id +
            " on " +
            moment().format("MMMM Do YYYY, h:mm a") +
            " for the following products : ";

        OrderService.updateOrderProducts(this.state.editRow.id, [newItem]).then(resProd => {
            if (resProd) {

                // let productsForNote = resProd.map((product) => {
                //     return product.products
                // })
                resProd.forEach((product) => {
                    var pt = product.productTypeId ? productTypes.filter(x => x.id === product.productTypeId)[0].name || "" : "";
                    var pst = product.productSubTypeId ? productSubTypes.filter(x => x.id === product.productSubTypeId)[0].name || "" : "";
                    // totalPoints += parseFloat(product.points);
                    noteText += product.qty + " " + pt + " " + pst + " | ";
                });
                OrderService.getFlatOrderActivity(this.state.editRow.id).then((res) => {
                    let note = {
                        type: "ActivityNote",
                        text: noteText,
                        createdAt: GlobalFunctions.getUTCMoment(),
                        account: res.activity.account,
                        accountId: res.activity.accountId,
                        task: false,
                        completed: true,
                        createdBy: { id: currentUser.id, name: currentUser.username },
                        createdById: currentUser.id,
                        patientName: res.patientName,
                        activityId: res.id,
                    };

                    NoteService.createActivityNote(res.id, note)
                        .then((res) => {
                            // currentNotes.unshift(res);
                        })
                        .catch(() => {});

                    let order = res;
                    if (!order.approvalDate) {
                        order.approvalDate = new Date();
                    }
                    order.lastUpdatedBy = {
                        id: currentUser.id,
                        username: currentUser.username,
                    };
                    order.lastUpdatedById = currentUser.id;
                    OrderService.updateFlatOrder(order).then((res) => {
                        this.getOrderProducts(this.state.editRow.id);
                        this.getOrderNotes(this.state.editRow.id);
                    }).catch(() => {});

                }).catch(() => {});

            }
            else {
                NotistackEnqueueSnackbar("There was an issue updating the products.", { variant: "warning" });
            }
        })
            .catch(() => {});
    }

    renderModal() {
        const { companyName } = this.context;
        let dataRow = this.state.editRow,
            ss = dataRow.sameOrSimilar,
            order = this.state.order,

            onFile =
                ss === "Change in Condition" ||
                ss === "Damage" ||
                ss === "Identified Same/Sim on File" ||
                ss === "Identified Patient in SNF";
        let t = this;
        let appr = order ? order.orderActivityApprovals ? this.state.order.orderActivityApprovals[0] ? this.state.order.orderActivityApprovals[0].approvals : null : null : null;

        function renderSSSection() {
            if (onFile === true) {
                return (
                    <MDBCol size="8">
                        <MDBInput
                            type={"checkbox"}
                            value={t.state.ssAcknowledge}
                            id={"sameSimCheckbox"}
                            onChange={(e) =>
                                t.setState({
                                    ssAcknowledge: e.target.checked,
                                })
                            }
                            label={"I acknowledge there is a same or similar on file."}
                        />
                    </MDBCol>
                );
            }
        }


        if (dataRow && dataRow.id) {

            // DateTime issue for java - The date is stored in UTC and sent in UTC,
            // changing the display is the best option currently
            // The following can be done on one line, but is very unreadable- Chip
            // let orgDate = dataRow.scheduledDeliveryDate,
            // 	parsedDate = null;
            // if (orgDate) {
            // 	parsedDate = GlobalFunctions.formatDateTime(orgDate)
            // }
            // let dbd = dataRow.deliverByDate
            // 	? new Date(dataRow.deliverByDate)
            // 	: "01/01/2999";

            this.getFlatOrder();
            return (
                <div className="overFlowFix">
                    <Modal
                        maxWidth="xl"
                        fullWidth={true}
                        isOpen={this.state.toggleModal}
                        disableEnforceFocus
                        toggle={() => {
                            return;
                        }}
                    >
                        <MDBModalHeader
                            className={"mHeaderTitle"}
                            style={{
                                backgroundColor: "#5581C1",
                                padding: "4px 10px",
                                color: "#FFF",
                            }}
                        >
                            <MDBRow>
                                <MDBCol size="6" style={{ paddingLeft: 10 }}>{dataRow.patientName}</MDBCol>
                                <MDBCol size="6" style={{ textAlign: "right", paddingRight: 10 }}>
                                    <span>Order Id: {dataRow.id}</span>
                                </MDBCol>
                                <Col md="12">
                                    <h6 style={{ color: "red" }}>{this.state.errorMessage}</h6>
                                </Col>
                            </MDBRow>
                        </MDBModalHeader>

                        {/* render navTabs */}
                        <MDBNav tabs className="nav-justified navFull" color={"blue"}
                            style={{ marginTop: "-10px" }}>
                            <MDBNavItem>
                                <MDBNavLink
                                    link
                                    to="#"
                                    active={this.state.ModalTabsOneActiveItem === "1"}
                                    onClick={() => {
                                        this.modalToggle("1", "1");
                                    }}
                                >
                                    Order Information
                                </MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink
                                    link
                                    to="#"
                                    
                                    onClick={() => {
                                        this.modalToggle("1", "2");
                                    }}
                                >
                                    Notes
                                </MDBNavLink>
                            </MDBNavItem>
                        </MDBNav>
                        <MDBTabContent
                            className="card deliveryNav"
                            activeItem={this.state.ModalTabsOneActiveItem}
                        >
                            <MDBTabPane tabId="1" role="tabpanel" activeItem={this.state.ModalTabsOneActiveItem}>
                                <Row style={{ marginTop: "10px", gap: "30px", padding: "16px" }}>
                                    <MDBCol size="2" style={{ marginTop: -4, }}>
                                        <MDBInput
                                            outline
                                            disabled={true}
                                            value={dataRow.sameOrSimilar || "Not Specified"}
                                            label={"Same or Similar"}
                                            sx={{ marginBottom: "16px", width: "100%" }}
                                        />

                                        <MDBInput
                                            outline
                                            disabled={true}
                                            value={dataRow.expectedShipDate || "Not Specified"}
                                            label={"Expected Ship Date"}
                                            sx={{ marginBottom: "16px", width: "100%" }}
                                        />
                                        <MDBInput
                                            outline
                                            disabled={true}
                                            value={appr && appr.deliverByDate ? moment(appr.deliverByDate).format("MM-DD-YYYY") : "Not Specified"}
                                            label={"Deliver By Date"}
                                            sx={{ width: "100%" }}
                                        />



                                        <div className={"uiOutlines"}>
                                            <MUIDateTimePicker
                                                disabled={this.disableCheck()}
                                                label="Scheduled Delivery Date"
                                                value={dataRow.scheduledDeliveryDate ? moment(GlobalFunctions.formatDateTime(dataRow.scheduledDeliveryDate)) : null}
                                                onOpen={() => {
                                                    if (!dataRow.scheduledDeliveryDate) {
                                                        let newDate = moment().hour(12).minute(0).second(1).millisecond(1);
                                                        if (appr && appr.deliverByDate) {
                                                            newDate = moment(appr.deliverByDate).clone().second(1).millisecond(1);
                                                        }
                                                        this.handleDeliveryDate(newDate);
                                                    }
                                                }}
                                                slotProps={{
                                                    field: {
                                                        clearable: true,
                                                    },
                                                    textField: {
                                                        fullWidth: true,
                                                        size: "small",
                                                        variant: 'outlined',
                                                        InputLabelProps: {
                                                            shrink: true
                                                        },
                                                    },
                                                    layout: {
                                                        sx: {
                                                            ul: {
                                                                '::-webkit-scrollbar': {
                                                                    width: '2px',
                                                                },
                                                                '::-webkit-scrollbar-thumb:hover': {
                                                                    backgroundColor: MUIGreyColor[500],
                                                                },
                                                                '::-webkit-scrollbar-thumb': {
                                                                    backgroundColor: MUIGreyColor[500],
                                                                },
                                                                '::-webkit-scrollbar-track': {
                                                                    backgroundColor: MUIGreyColor[300],
                                                                }
                                                            }
                                                        }
                                                    }
                                                }}
                                                onChange={(value) => this.handleDeliveryDate(value)}
                                                views={['year', 'month', 'day', 'hours', 'minutes']}
                                                shouldDisableDate={(date) => {
                                                    if (!appr || !appr.deliverByDate) {
                                                        return false;
                                                    }

                                                    const deliverByDate = moment(appr.deliverByDate);
                                                    return date.isAfter(deliverByDate, 'day');
                                                }}
                                            />
                                        </div>


                                        {this.renderServiceLocationDropdown()}
                                        {this.renderTechnicianDropdown()}

                                        {this.renderReasonsDropdown()}
                                        {/*{this.renderDisableNotification()}*/}
                                    </MDBCol>
                                    {dataRow.orderType.toLowerCase() !== "billing issue" ? (
                                        <MDBCol size="9">{this.renderProductsList()}</MDBCol>
                                    ) : null}
                                </Row>
                            </MDBTabPane>
                            <MDBTabPane tabId="2" role="tabpanel" activeItem={this.state.ModalTabsOneActiveItem}>
                                <MDBRow style={{ marginTop: "10px", gap: "30px", padding: "16px" }}>
                                    <MDBCol size={7}>


                                        {/* {this.renderNotesList()} */}
                                        <div style={{ overflowY: "scroll", maxHeight: "430px", overflowX: "hidden"}} >
                                            {this.state.orderNotes.map((note) => {
                                                return (
                                                    <MDBCard style={{ backgroundColor: "#FFF7D1", margin: 6 }} key={note.id}>

                                                        <MDBRow>
                                                            <MDBCol size="6">
                                                                {GlobalFunctions.formatDateTime(note.createdAt)}
                                                            </MDBCol>

                                                            <MDBCol size="5">
                                                                {note.createdBy ? note.createdBy.firstname + " " + note.createdBy.lastname : ""}
                                                            </MDBCol>
                                                        </MDBRow>


                                                        <MDBCardBody>
                                                            <p style={{ whiteSpace: "pre-line" }}>{note.text}</p>
                                                        </MDBCardBody>
                                                    </MDBCard>
                                                );
                                            })}
                                        </div>


                                    </MDBCol>
                                    <MDBCol size={4} >
                                        <MDBInput
                                            type="textarea"
                                            label="Add Note"
                                            value={this.state.nNote}
                                            onChange={this.handleNoteChange.bind(this)}
                                            outline
                                            fullWidth={true}
                                            inputProps={{ style: { height: "430px" } }}
                                        />
                                    </MDBCol>
                                </MDBRow>
                            </MDBTabPane>
                        </MDBTabContent>


                        {/*</ModalBody>*/}
                        <MDBRow style={{ justifyContent: "flex-end" }}>
                            {renderSSSection()}
                        </MDBRow>
                        <MDBModalFooter style={{ padding: "5px", justifyContent: "space-between" }}>

                            <MDBCol size="2" style={{ float: "right", justifyContent: "right" }}>
                                <Button
                                    floating
                                    rounded
                                    size="sm"
                                    data-tip={"Save"}
                                    //disabled={true}
                                    disabled={onFile === true && this.state.ssAcknowledge !== true}
                                    color={"success"}
                                    onClick={() => {
                                        this.updateOrder();
                                    }}
                                    style={{ marginRight: "16px"}}
                                >
                                    <MDBIcon fas icon="save" style={{ fontSize: "2em" }} />
                                </Button>
                                <Button
                                    floating
                                    size="sm"
                                    color={"red"}
                                    data-tip={"Cancel"}
                                    onClick={() => this.toggleEditModal()}
                                >
                                    <MDBIcon icon="times" style={{ fontSize: "2em" }} />
                                </Button>
                            </MDBCol>
                            <ReactTooltip />
                        </MDBModalFooter>
                    </Modal>
                </div>
            );
        } else {
            return <div />;
        }
    }

    disableDelivery() {
        const { currentUser } = this.context;

        if (
            currentUser.role === "WAREHOUSE_TECHNICIAN" || currentUser.role === "ADMIN"
        ) {
            return false;
        }
    }

    disableCheck() {
        //const { companyName } = this.context;
        let products = this.state.orderProducts,
            //order = this.state.order,
            result = false;

        if (this.state.editRow && this.state.editRow.orderType.toLowerCase() === "billing issue") {
            return false;
        }

        if (products && products.length === 0) {
            return true;
        }
        else
            result = false;

        //if (order.orderType === "New" && companyName !== "corkmedical") {
        //	products.map(product => {
        //		if (!product.btitemId || product.btitemId === "null" || (product.productType && product.productType.requiresSerialNumber === true && (!product.serial || product.serial === ""))) {
        //			result = true;
        //		}
        //		return result;
        //	});
        //}
        //if (result === false) {
        //	if (["local", "uat", "rehabmedical"].includes(companyName) && order && [2, 26].includes(order.serviceLocationId)) {
        //		result = order.patientRegistered !== true && order.orderType === "New";
        //  }
        //}


        if (result === false) {
            return this.disableDelivery();
        } else
            return result;

    }

    modalToggle = (tabset, tab) => {
        if (this.state.ModalTabsOneActiveItem !== tab) {
            this.setState({
                ModalTabsOneActiveItem: tab,
            });
        }
    };

    // renderDisableNotification() {
    // 	const { companyName } = this.context;
    // 	if(this.disableCheck() && companyName !== "corkmedical"){
    // 		return (
    // 			<div className={"disableNotification"}>
    // 				*All products need a brightree id and serial number before you can schedule
    // 			</div>
    // 		);
    // 	}
    // }

    renderReasonsDropdown() {
        const { reasons } = this.context;

        let o = this.state.editRow;

        return (
            <div className={"uiOutlines smallMargin"}>
                <MUITextField
                    disabled={this.disableDelivery()}
                    id="outlined-select-statusReason"
                    select
                    size="small"
                    fullWidth
                    label="Status Reason"
                    value={o.reasonId || ""}
                    onChange={(e) => this.handleReasonChange(e.target.value)}
                    variant="outlined"
                >
                    {reasons.map((r, idx) => {
                        //2 = readyToDeliver
                        if (r.orderStatus === 2) {
                            if (r.description === "Scheduled") {
                                if (!o.technicianId || !o.scheduledDeliveryDate) {
                                    return (
                                        <MUIMenuItem disabled key={idx} value={r.id}>
                                            {r.description}
                                        </MUIMenuItem>
                                    );
                                }
                            }

                            if (o.orderType === "Pickup") {
                                //Only show the options for "Scheduled" id 13  and "No Answer / Not Able to Deliver" id 20 for Pickup tickets
                                if (r.id === 20 || r.id === 13 || o.reason === r.description) {
                                    return (
                                        <MUIMenuItem key={idx} value={r.id}>
                                            {r.description}
                                        </MUIMenuItem>
                                    );
                                }

                            }
                            else {
                                return (
                                    <MUIMenuItem key={idx} value={r.id}>
                                        {r.description}
                                    </MUIMenuItem>
                                );
                            }
                        }
                        return null;
                    })}
                </MUITextField>
            </div>
        );
    }

    // toggleNoteCollapse = () => {
    //     this.setState({
    //         noteToggle: !this.state.noteToggle,
    //     });
    // };

    handleNoteChange = (e) => {
        this.setState({
            nNote: e.target.value,
        });
    };


    renderCollapse(item) {
        if (item.deliveries.length === 0) {
            return <div />;
        }
        return (
            <Collapse isOpen={item.isOpen}>
                {item.deliveries.map((del, index) => {
                    return (
                        <Row key={index}>
                            <Col md={"8"}>
                                <span style={{ paddingLeft: "10px" }}>{del.date}</span>
                            </Col>
                            <Col md={"4"}>
                                <span
                                    data-for="notes"
                                    style={{
                                        cursor: "pointer",
                                        textAlign: "right",
                                        margin: 5,
                                    }}
                                    onClick={() => this.printTechTooltip(item.name, del.date)}
                                    onMouseEnter={() =>
                                        this.getTooltipContent(del.orders, item.name, del.date)
                                    }
                                    onMouseLeave={() => this.setState({ techTooltip: "" })}
                                >
                                    {del.orders.length}
                                </span>
                            </Col>
                        </Row>
                    );
                })}
                <hr style={{ borderColor: "#555555", borderWidth: "3px" }} />
            </Collapse>
        );
    }

    renderSideBar() {
        let ds = this.state.dataTechSchedule;
        
        return (
            <CardBody className="deliveriesSidebarContent">
                <MDBSelect
                    color="info"
                    value={this.state.selectedLocationIds[0]}
                    style={{ margin: "5px 0", width: "100%" }}
                    options={this.state.locationList}
                    getValue={this.handleLocationChange}
                    variant="standard"
                    renderValue={(selectedValue) => {
                        if(!selectedValue) {
                            return "Choose Location";
                        }

                        const option = this.state.locationList.find(
                            (lo) => lo.value === selectedValue
                        );
                        return option?.text ?? selectedValue;
                    }}
                />
                {this.state.selectedLocationIds.length === 0 ? (
                    <MUIAlert severity="warning" sx={{ mt: 1 }}>
                        Choose a location
                    </MUIAlert>
                ) : null}
                <div>
                    <div
                        style={{
                            paddingRight: 0,
                            width: "100%",
                            paddingTop: "10px",
                        }}
                    >
                        {this.state.techScheduleLoaded && ds.length > 0 ? (
                            ds.map((item, id) => {
                                return (
                                    <div key={id} style={{ maxWidth: "90%" }}>
                                        <div
                                            style={{
                                                paddingTop: "6px",
                                                paddingBottom: "6px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => this.toggleTechRow(id)}
                                        >
                                            <MDBIcon
                                                icon="caret-down"
                                                style={{ color: item.fill, fontSize: 28 }}
                                            />

                                            <h6 style={{ display: "inline" }}>{item.name}</h6>
                                            <hr
                                                style={{ borderColor: "#555555", borderWidth: "3px" }}
                                            />
                                        </div>

                                        {this.renderCollapse(item)}
                                    </div>
                                );
                            })
                        ) : this.state.selectedLocationIds.length > 0 &&
                            !this.state.techScheduleLoaded ? (
                            <Container className="mt-5">
                                <div style={{ textAlign: "center", verticalAlign: "center" }}>
                                    <Spinner multicolor />
                                </div>
                            </Container>
                        ) : (
                            <div />
                        )}
                    </div>
                    <ReactTooltip />
                </div>
            </CardBody>
        );
    }

    renderReadyToScheduleHeader() {
        let unscheduled = this.state.dataNotScheduled;

        return (
            <div className="deliveriesGridHeader">
                <span className="deliveriesGridTitle">
                    Ready to Schedule - {unscheduled ? unscheduled.length : 0}
                </span>
                <Button
                    floating
                    size="sm"
                    color="white"
                    title="Download CSV"
                    aria-label="Download deliveries as CSV"
                    onClick={this.clientCSV.bind(this)}
                >
                    <MDBIcon icon="download" />
                </Button>
            </div>
        );
    }

    patientCalledRadio = (result) => () => {
        this.setState({
            callRadio: result,
        });
    };

    generatePhoneLink(phone) {
        let regEx = /\(?\d{3}\)?\s*-?\s*\d{3}\s*-?\s*\d"4"/;
        return phone.match(regEx);
    }

    renderCallPatientModal() {
        let st = this.state,
            order = st.equipOrder,
            phoneLink = order.phone ? this.generatePhoneLink(order.phone) : "";
        return (
            <Modal
                centered
                isOpen={st.callPatientModal}
                toggle={() => this.toggleCallPatientModal()}
            >
                <ModalBody>
                    <CardHeader
                        style={{ marginBottom: "1rem" }}
                        className="form-header text-center font-weight-bold blue-gradient"
                    >
                        <h3>{order ? order.patientName : ""}</h3>
                    </CardHeader>
                    <div align="left">
                        {phoneLink ? (
                            <a className={"callPatientLink"} href={"tel:+1" + phoneLink[0]}>
                                <MDBIcon
                                    style={{ margin: "0 10px 0 0" }}
                                    size="lg"
                                    data-tip={phoneLink[0]}
                                    icon="phone"
                                />
                                {"Call Patient: " + phoneLink[0]}
                            </a>
                        ) : (
                            <MDBInput
                                value={order.phone}
                                icon="phone"
                                group
                                disabled={true}
                                type="text"
                            />
                        )}
                        <MDBInput
                            value={order.patientName}
                            icon="user"
                            group
                            disabled={true}
                            type="text"
                        />
                        <MDBInput
                            value={
                                order.address +
                                ", " +
                                order.city +
                                "\n" +
                                order.state +
                                " " +
                                order.zipCode
                            }
                            icon="home"
                            group
                            className="text-left"
                            disabled={true}
                            type="textarea"
                        />
                        <MDBInput
                            value={order.category + " - " + order.product}
                            icon="wheelchair"
                            group
                            disabled
                            type="text"
                        />
                        <MDBInput
                            className="callPatientInput"
                            rows="2"
                            onChange={(e) => {
                                this.setState({ callPatientNote: e.target.value });
                            }}
                            label={"Add notes..."}
                            icon="notes-medical"
                            group
                            type="textarea"
                        />
                        <MDBFormInline>
                            <MDBInput
                                onClick={this.patientCalledRadio(1)}
                                checked={st.callRadio === 1}
                                label="Answered"
                                type="radio"
                                id="radio1"
                            />
                            <MDBInput
                                onClick={this.patientCalledRadio(2)}
                                checked={st.callRadio === 2}
                                label="Didn't answer"
                                type="radio"
                                id="radio2"
                            />
                        </MDBFormInline>
                    </div>
                </ModalBody>
                <ModalFooter style={{ marginTop: "10px", paddingLeft: "30px" }}>
                    <Button
                        floating
                        size="sm"
                        color={"danger"}
                        data-tip={"Close"}
                        onClick={() => this.toggleCallPatientModal()}
                    >
                        <MDBIcon icon="times" style={{ fontSize: "2em" }} />
                    </Button>
                    <Button
                        floating
                        size="sm"
                        color={"success"}
                        data-tip={"Save Order"}
                        onClick={this.handleCallPatient}
                    >
                        <MDBIcon icon="save" style={{ fontSize: "2em" }} />
                    </Button>
                </ModalFooter>
                <ReactTooltip />
            </Modal>
        );
    }

    handleCallPatient = () => {
        let st = this.state,
            cr = st.callRadio,
            order = st.equipOrder,
            note = st.callPatientNote;

        if (!cr) {
            NotistackEnqueueSnackbar("Please select if patient answered", { variant: "warning" });
            return;
        }

        this.saveNote(order, note);

        let callLog = {
            answered: cr === 1,
            orderId: order.id,
        };

        CallLogService.createCallLog(callLog)
            .then((res) => {
                this.setState({
                    callRadio: null,
                });
                this.toggleCallPatientModal();
                this.retrieveDeliveries(this.state.selectedLocationIds);
            })
            .catch(() => {});
    };

    renderEquipApprovalModal() {
        let st = this.state,
            order = st.equipOrder;
        return (
            <Modal
                centered
                isOpen={st.equipApprovalModal}
                toggle={() => this.toggleEquipmentApprovalModal()}
            >
                <ModalBody>
                    <CardHeader
                        style={{ marginBottom: "1rem" }}
                        className="form-header text-center font-weight-bold blue-gradient"
                    >
                        <h3>Equipment Acknowledgment</h3>
                    </CardHeader>
                    <div align="left">
                        <MDBInput
                            key={order.id}
                            id={"equipCheckBox"}
                            onChange={this.handleEquipmentApproval.bind(this)}
                            value={st.equipApproval}
                            label={
                                "I hereby acknowledge that all equipment have been ordered for order " +
                                order.id
                            }
                            type="checkbox"
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <MDBBtn
                        color="secondary"
                        onClick={() => this.toggleEquipmentApprovalModal()}
                    >
                        Close
                    </MDBBtn>
                    <MDBBtn
                        disabled={!st.equipApproval}
                        color="primary"
                        onClick={() => this.equipAcknowledgeClicked(order)}
                    >
                        Acknowledge
                    </MDBBtn>
                </ModalFooter>
            </Modal>
        );
    }

    equipAcknowledgeClicked(order) {
        const { currentUser } = this.context;
        let note =
            currentUser.username +
            " acknowledged that all equipment has been ordered for order " +
            this.state.equipOrder.id;
        order.equipmentOrderedDate = new Date().toLocaleString();
        this.updateOrder(order, note);
    }

    toggleEquipmentApprovalModal = () => {
        this.setState({
            equipApprovalModal: !this.state.equipApprovalModal,
        });
    };

    toggleCallPatientModal = () => {
        this.setState({
            callPatientModal: !this.state.callPatientModal,
        });
    };

    handleEquipmentApproval = (event) => {
        this.setState({ equipApproval: event.target.checked });
    };

    renderContent() {
        if (this.state.firstLoad) {
            setTimeout(() => {
                this.setState({ firstLoad: false });
            }, 200);
        }
        if (this.state.firstLoad) {
            return <MDBCol>
                <Spinner small />
            </MDBCol>;
        }
        return (
            <MUIThemeProvider theme={fixedLightMaterialUITheme}>
            <Container className="deliveriesPage">
                {this.renderModal()}
                {this.renderEquipApprovalModal()}
                {this.renderCallPatientModal()}

                {/* renderTooltipCards*/}
                <div id={"techTooltip"} className={"techTooltipBoxOuter"}>
                    <div className="wrapper">
                        {this.state.techTooltip ? (
                            this.state.techTooltip.map((c, idx) => {
                                return (
                                    <div className={"techTooltipBox"} key={idx}>
                                        {c}
                                    </div>
                                );
                            })
                        ) : (
                            <div />
                        )}
                    </div>
                </div>


                <div className="deliveriesLayout">
                    <aside className={this.state.isOpen ? "deliveriesSidebar" : "deliveriesSidebar deliveriesSidebarCollapsed"}>
                        <Button
                            className="deliveriesFilterToggle"
                            floating
                            size="sm"
                            color="orange"
                            data-tip="Hide/Show Filters"
                            aria-label="Hide or show delivery filters"
                            onClick={() => this.toggleCollapse()}
                        >
                            <MDBIcon icon="filter" />
                        </Button>
                        <ReactTooltip />
                        {this.state.isOpen ? (
                            <Card className="deliveriesSidebarCard">
                                {this.renderSideBar()}
                            </Card>
                        ) : null}
                    </aside>
                    <main className="deliveriesGridPanel">
                        {this.renderReadyToScheduleHeader()}
                        <div className="deliveriesGridContent">
                            <ReadyToScheduleGrid
                                history={this.props.history}
                                isLoaded={this.state.isLoaded}
                                selectedLocationIds={this.state.selectedLocationIds}
                                dataNotScheduled={this.state.dataNotScheduled}
                                renderEditOrderModal={this.renderEditOrderModal.bind(this)}
                            />
                        </div>
                    </main>
                </div>
                <ReactTooltip />
            </Container>
            </MUIThemeProvider>
        );
    }
}
